import { InputHTMLAttributes, ReactNode } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: ReactNode
}

export default function Input({ icon, disabled, style, ...props }: InputProps) {
  const inputStyles: React.CSSProperties = {
    width: '100%',
    padding: icon ? '0.875rem 1rem 0.875rem 2.5rem' : '0.875rem 1rem',
    fontSize: '1rem',
    border: '1px solid var(--color-border)',
    borderRadius: '0.5rem',
    outline: 'none',
    transition: 'border-color 0.2s',
    backgroundColor: disabled ? 'var(--base-100)' : 'white',
    ...style,
  }

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.style.borderColor = 'var(--color-primary)'
  }

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.style.borderColor = 'var(--color-border)'
  }

  if (icon) {
    return (
      <div style={{ position: 'relative' }}>
        <span style={{
          position: 'absolute',
          left: '1rem',
          top: '50%',
          transform: 'translateY(-50%)',
          color: 'var(--color-text-secondary)',
          fontSize: '1.125rem',
          pointerEvents: 'none'
        }}>
          {icon}
        </span>
        <input
          {...props}
          disabled={disabled}
          style={inputStyles}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </div>
    )
  }

  return (
    <input
      {...props}
      disabled={disabled}
      style={inputStyles}
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  )
}

